<template>
  <div>
    <a-number-field
      :varName="getVarNameTime"
      :varLabel="getVarLabelTime"
      :varRequired="true"
      :varInitial="getVarInitialTime"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      :min=0
    />
    <a-select-field
      :varName="getVarNameUnit"
      :varLabel="getVarLabelUnit"
      :varRequired="true"
      :varInitial="getVarInitialUnit"
      :formLayout="formLayout"
      :size="size"
      :disabled="disabled"
      type="array"
      :varOptions="units"
    />
  </div>
</template>

<script>

export default {
  data() {
    return {
      
    };
  },
  components: {

  },
  computed: {
      getVarLabelUnit() {
          return `${this.varVerbose} Lifetime Unit`;
      },
      getVarNameUnit() {
          return `${this.parentName}.${this.varName}.unit`;
      },
      getVarInitialUnit() {
          return this.data[this.parentName][this.varName].unit;
      },
      getVarLabelTime() {
          return `${this.varVerbose} Lifetime Duration`;
      },
      getVarNameTime() {
          return `${this.parentName}.${this.varName}.lifetime`;
      },
      getVarInitialTime() {
          return this.data[this.parentName][this.varName].lifetime;
      }
  },
  props: {
    formLayout: String,
    size: String,
    data: Object,
    parentName: String,
    varName: String,
    varVerbose: String,
    disabled: {
      type: Boolean,
      default: false
    },
    units: {
      type: Array,
      default: () => ['seconds', 'minutes', 'hours']
    }
  }
};
</script>